<template>
  <div
    class="mb-2 flex flex-col rounded-md border border-lk-light-gray p-3 text-gray-700 md:flex-row md:items-center md:p-4"
  >
    <div class="mb-2 flex items-center md:mb-0">
      <div class="mr-3 flex items-center justify-center rounded-full bg-lk-light-purple p-1">
        <TicketIcon class="size-5 text-white md:size-6" />
      </div>
      <div class="flex flex-col">
        <p class="text-sm font-medium md:text-base">
          {{ discount.name }}
          <span
            class="rounded-full px-2 py-1 text-xs"
            :class="{
              'bg-green-100 text-green-800': !isExpired,
              'bg-red-100 text-red-800': isExpired,
            }"
          >
            {{ isExpired ? 'Expirado' : 'Activo' }}
          </span>
        </p>
        <p class="text-xs font-medium md:text-sm">{{ discount.totalDiscount }}% de descuento</p>
        <p class="text-xs text-gray-500 md:text-sm">
          Activo desde: {{ timeToDate(discount.startDate) }} - hasta: {{ timeToDate(discount.endDate) }}
        </p>
      </div>
    </div>
    <div class="mb-2 flex items-center gap-2 md:mb-0 md:ml-auto">
      <button
        class="rounded-md border border-lk-green bg-white px-3 py-1 text-xs text-lk-green transition-colors hover:bg-lk-green hover:text-white md:text-sm"
        @click="$emit('view-products', discount)"
      >
        Ver productos
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { TicketIcon } from '@heroicons/vue/24/outline';
import dateTools from './use/date-tools';

const { timeToDate } = dateTools();

const props = defineProps<{
  discount: Discount;
}>();

defineEmits<{
  'view-products': [discount: Discount];
}>();

const isExpired = computed(() => {
  const endDate = new Date(props.discount.endDate);
  return endDate < new Date();
});
</script>
